import { Check, LockKeyhole, Palette, Sparkles } from 'lucide-react';
import { CASINO_THEMES, applyCasinoTheme, getCasinoTheme } from '../theme/casinoThemes';

export default function CasinoThemePicker() {
  const current = getCasinoTheme();

  return (
    <section className="vl-theme-picker" aria-labelledby="casino-theme-title" data-testid="casino-theme-picker">
      <div className="vl-theme-picker__heading">
        <span className="vl-theme-picker__icon"><Palette /></span>
        <div>
          <p className="vl-eyebrow">Lobby appearance</p>
          <h2 id="casino-theme-title">Choose your world</h2>
        </div>
      </div>
      <div className="vl-theme-picker__grid">
        {Object.values(CASINO_THEMES).map((theme) => {
          const active = theme.id === current.id;
          const available = theme.status === 'active';
          return (
            <button
              key={theme.id}
              type="button"
              className={`vl-theme-card vl-theme-card--${theme.id}`}
              data-active={active ? 'true' : 'false'}
              disabled={!available}
              onClick={() => applyCasinoTheme(theme.id)}
            >
              <span className="vl-theme-card__art" aria-hidden="true"><Sparkles /></span>
              <span className="vl-theme-card__copy">
                <strong>{theme.name}</strong>
                <small>{theme.description}</small>
              </span>
              <span className="vl-theme-card__state">
                {active ? <><Check /> Active</> : <><LockKeyhole /> Soon</>}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
